import { createInputTokens } from '../tokens/components.js';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * Textarea Component Configuration
 */
export function createTextarea(s: SemanticTokens) {
  const inputTokens = createInputTokens(s);
  return {
      root: {
        background: inputTokens.bg,
        disabledBackground: inputTokens.bgDisabled,
        filledBackground: inputTokens.bg,
        filledHoverBackground: inputTokens.bgHover,
        filledFocusBackground: inputTokens.bg,
        borderColor: inputTokens.border,
        hoverBorderColor: inputTokens.border,
        focusBorderColor: inputTokens.borderFocus,
        invalidBorderColor: inputTokens.borderInvalid,
        color: inputTokens.fg,
        disabledColor: inputTokens.fgDisabled,
        placeholderColor: inputTokens.placeholder,
        invalidPlaceholderColor: inputTokens.placeholder,
        shadow: 'none',
        paddingX: inputTokens.base.paddingX,
        paddingY: inputTokens.base.paddingY,
        borderRadius: inputTokens.base.radius,
        focusRing: { width: '0', style: 'none', color: 'transparent', offset: '0', shadow: 'none' },
        transitionDuration: inputTokens.base.transition,
      },
      colorScheme: {
        light: {
          root: {
            background: inputTokens.bg,
            disabledBackground: inputTokens.bgDisabled,
            filledBackground: inputTokens.bg,
            filledHoverBackground: inputTokens.bgHover,
            filledFocusBackground: inputTokens.bg,
            borderColor: inputTokens.border,
            hoverBorderColor: inputTokens.border,
            focusBorderColor: inputTokens.borderFocus,
            invalidBorderColor: inputTokens.borderInvalid,
            color: inputTokens.fg,
            disabledColor: inputTokens.fgDisabled,
            placeholderColor: inputTokens.placeholder,
            invalidPlaceholderColor: inputTokens.placeholder,
          },
        },
      },
      css: () => `
        /* Disabled placeholder color */
        .p-textarea:disabled::placeholder {
          color: ${inputTokens.fgDisabled};
        }
      `,
      };
}
export const textarea = createTextarea(SEMANTIC);